import { render, staticRenderFns } from "./ProductCustomPropertyIframe.vue?vue&type=template&id=0a756dd1&"
import script from "./ProductCustomPropertyIframe.vue?vue&type=script&lang=ts&"
export * from "./ProductCustomPropertyIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports